import { render, staticRenderFns } from "./UOM.vue?vue&type=template&id=64706aa1&"
import script from "./UOM.vue?vue&type=script&lang=ts&"
export * from "./UOM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64706aa1')) {
      api.createRecord('64706aa1', component.options)
    } else {
      api.reload('64706aa1', component.options)
    }
    module.hot.accept("./UOM.vue?vue&type=template&id=64706aa1&", function () {
      api.rerender('64706aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/UOM.vue"
export default component.exports